import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarPlus } from '@fortawesome/free-solid-svg-icons';
import type { ScheduleHeaderProps } from './types';
import { HeaderSection, TitleGroup, Title, Subtitle, PrimaryButton, TitleIcon } from './styles';

const ScheduleHeader: React.FC<ScheduleHeaderProps> = ({ onCreateClick }) => (
  <HeaderSection>
    <TitleGroup>
      <Title level={3}>
        <TitleIcon>
          <FontAwesomeIcon icon={faCalendarPlus} />
        </TitleIcon>
        Schedules
      </Title>
      <Subtitle>All the available schedules. See details, create, delete or update existing schedules.</Subtitle>
    </TitleGroup>
    <PrimaryButton type="primary" icon={<FontAwesomeIcon icon={faCalendarPlus} />} onClick={onCreateClick}>
      Create Schedule
    </PrimaryButton>
  </HeaderSection>
);

export default React.memo(ScheduleHeader);
